export function getNumberWithOrdinal(number: number, locale: string) {
  const localeHandlers: Record<string, (num: number) => string> = {
    en: (num: number) => {
      const ordinals = ['th', 'st', 'nd', 'rd'];
      const remainder100 = num % 100;

      return num + (ordinals[(remainder100 - 20) % 10] || ordinals[remainder100] || ordinals[0]);
    },
    nl: (num: number) => {
      const ordinals = ['de', 'ste'];
      const remainder10 = num % 10;
      const remainder100 = num % 100;

      // Numbers ending in 11 through 19 always use "de"
      if (remainder100 >= 11 && remainder100 <= 19) {
        return num + ordinals[0];
      }

      // Special cases for 1 and 8
      if (remainder10 === 1 || remainder10 === 8) {
        return num + ordinals[1];
      }

      // Default case: "de"
      return num + ordinals[0];
    },
  };

  // Use English if the locale is not supported
  const handler = localeHandlers[locale] || localeHandlers.en;

  return handler(number);
}
